import React from "react";
import "../styles/Dashboard.css";
import StatsCard from "./StatsCard";
import { useState } from "react";
import { useEffect } from "react";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
// ==============   charts Import s =================

import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  ArcElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { Pie } from "react-chartjs-2";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend
);
// ==============  End charts Import s =================
const DashMain = () => {
  const [statsLoading, setStatsLoading] = useState(false);
  // ==============  Booking =================
  const [bookings, setBookings] = useState([]);
  let token = localStorage.getItem("token");
  const fetchBookings = () => {
    axios({
      method: "GET",
      url: "https://holiday-planner-4lnj.onrender.com/api/v1/booking/view",
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((Response) => {
        setBookings(Response.data);
        console.log(Response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchBookings();
  }, []);
  // ============== End Booking =================
  //  ======  charts fetching  ===============
  const [chart, setChart] = useState([]);
  const fetchChart = () => {
    axios({
      method: "GET",
      url: "https://holiday-planner-4lnj.onrender.com/api/v1/count?year=2023",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((Response) => {
        setChart(Response.data);
        console.log(Response);
      })

      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchChart();
  }, []);
  //  ======  End charts fetching  ===============
  //  ===================  Tour fetching ============================

  const [tourLists, setTourLists] = useState([]);

  const fetchTourList = () => {
    setStatsLoading(true);
    axios({
      method: "GET",
      url: "https://holiday-planner-4lnj.onrender.com/api/v1/tour",
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((Response) => {
        setStatsLoading(false);
        setTourLists(Response.data);
        console.log(Response);
      })
      .catch((error) => {
        setStatsLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    fetchTourList();
  }, []);

  // ===================== End Tour fetching ========================

  // ===================== User Fetching ==========================
  const [users, setUsers] = useState([]);

  const fetchUsers = () => {
    axios({
      method: "GET",
      url: "https://holiday-planner-4lnj.onrender.com/api/v1/auth/users",
      headers: {
        Authorization: `bearer ${token}`,
      },
    })
      .then((Response) => {
        setUsers(Response.data);
        console.log(Response);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchUsers();
  }, []);
  // ===================== End User Fetching ======================
  // ==============   charts declaration =================
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Tour Bookings",
      },
    },
  };

  const labels = chart?.map((cart) => cart.label);

  const data = {
    labels,
    datasets: [
      {
        label: "number of Bookings",
        data: chart?.map((cart) => cart.count),
        backgroundColor: "rgb(194,157,89)",
      },
    ],
  };

  const dataPie = {
    labels: ["January", "February", "March", "April", "May", "June", "July"],

    datasets: [
      {
        label: " Number Of Tours",
        data: [12, 19, 3, 5, 2, 3, 5],
        backgroundColor: [
          "#B9A943",
          "#23556C",
          "#6D5322",
          "#303436",
          "#C39B46",
          "#005236",
          "#D0D8B2",
        ],

        borderWidth: 1,
      },
    ],
  };
  // ==============   End charts declaration =================

  return (
    <div className="dashboard-center">
      <div className="stat-card">
        <StatsCard
          title="Tours"
          amount={
            statsLoading ? (
              <ClipLoader color="#c29d59" size={15} className="statsloader" />
            ) : (
              tourLists.length
            )
          }
        />
        <StatsCard
          title="Booking"
          amount={
            statsLoading ? (
              <ClipLoader color="#c29d59" size={15} className="statsloader" />
            ) : (
              bookings.length
            )
          }
        />
        <StatsCard
          title="users"
          amount={
            statsLoading ? (
              <ClipLoader color="#c29d59" size={15} className="statsloader" />
            ) : (
              users.length
            )
          }
        />
      </div>

      <div className="charts">
        <div className="left-chart">
          <Bar options={options} data={data} />
        </div>
        <div className="right-chart">
          <Pie data={dataPie} />
        </div>
      </div>
    </div>
  );
};

export default DashMain;
